import React,{useState,useEffect} from 'react'
import { Accordion, Spinner } from 'flowbite-react'
import axios from 'axios'
export default function CourseEvaluation({course_id}) {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [lan, setLan] = useState('bangla')
    const baseURL = "https://mukti-backend-bd.onrender.com"
    const getData = async () => {
        try {
            const res = await axios.get(`${baseURL}/eval/${course_id}`)
            console.log(res.data)
            setData(res.data)
            setLoading(false)
        } catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        if (localStorage.getItem('language') === 'english') {
            setLan('english')
        } else {
            setLan('bangla')
        }
        getData()
    }, [])
  return loading? <Spinner/> :(
    <div className='w-full flex flex-wrap items-center justify-center'>
          
            
               { (lan=="english" && <a href="https://forms.gle/6pxZdANZq2yTkzyT7" target='_blank' class="inline-flex text-center items-center text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900">
                    Get started
                    <svg class="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                </a>)}
                 {(lan=="bangla" && <a href="https://forms.gle/6pxZdANZq2yTkzyT7" target='_blank' class="inline-flex text-center items-center text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900">
                    শুরু করো
                    <svg class="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                </a>)}
            
         
    </div>
  )
}
